import Vue from 'vue';
import _ from 'lodash';
import {
    GET_SERVICE_LIST_REQUEST,
    GET_SERVICE_LIST_SUCCESS,
    GET_SERVICE_LIST_FAILURE,
    SERVICE_LIST_CHOOSE_ITEM,
    SERVICE_LIST_CHOOSE_ADD_ITEM,
    EDIT_SERVICVE_ITEM_PROPS,
    UPDATE_CHOSEN_SERVICE_IDS,
    UPDATE_CHOSEN_SERVICE_WORKERS,
    INIT_ORDER_CHOSEN_SERVICE,
    INIT_ORDER_CHOSEN_SERVICE_IDS,
    // CUSTOMIZE_SERVICE_CACHE,
    SERVICE_LIST_CONFIG_RESET,
    SERIALIZE_CARD_FOR_SERVICE,
    UPDATE_CARD_FOR_SERVICE,

    GET_USER_STORE_CARDS_REQUEST, // 爱车卡列表
    GET_USER_STORE_CARDS_SUCCESS,
    GET_USER_STORE_CARDS_FAILURE,
    GET_BOUGHT_SERVICE_LIST_SUCCESS,
    GET_BOUGHT_SERVICE_LIST_FAILURE,
    TEMPORARY_SERVICE_CACHE,
    TEMPORARY_SERVICE_DOUBLE_NAME,
    GET_WRITEOFF_AUTH
} from '../mutationTypes';

const state = {
    loading: false,
    list: [], // 添加服务弹窗显示
    chosen: [], // 选中服务
    allService: [], // 输入框过滤服务
    // customize: [], // 用户自定义服务
    serviceTotal: 0,
    chosenIds: [], // CheckBox主键
    cardLoading: false, // 用户爱车卡
    boughtServiceList: [], // 已购服务
    cardList: [],
    cardForService: {},
    cateNameList: [], // 临时服务类下的名称集合，没有临时服务类则为空
    hideOrderNum: 0, // 没有核销权限而隐藏的订单数目
    writeoffAuthList: [] // 核销权限列表
};
const mutations = {
    [INIT_ORDER_CHOSEN_SERVICE](state, chosen) {
        state.chosen = chosen;
    },
    [INIT_ORDER_CHOSEN_SERVICE_IDS](state, ids) {
        state.chosenIds = ids;
    },
    [GET_SERVICE_LIST_REQUEST](state) {
        state.loading = true;
    },
    [GET_SERVICE_LIST_SUCCESS](state, res) {
        state.loading = false;

        state.list = res.common;
        // state.customize = res.customize;
        state.allService = _.flattenDepth(_.map(res.common, (item) => {
            if (item.cateId !== 0 || item.cateName === '临时服务') { // 增加临时服务可搜索
                return item.children;
            }
            return [];
        }));
        this.commit('TEMPORARY_SERVICE_DOUBLE_NAME');
    },
    [TEMPORARY_SERVICE_CACHE](state, service) {
        if (state.cateNameList.length) {
            state.list[state.list.length - 1].children.unshift(service);
        } else {
            const item = {
                cateId: 0,
                cateName: '临时服务',
                children: [{...service}],
                highFrequency: 0,
            };
            state.list.push(item);
        }
        this.commit('TEMPORARY_SERVICE_DOUBLE_NAME');
    },
    // 获取临时服务的名称
    [TEMPORARY_SERVICE_DOUBLE_NAME](state) {
        const cateName = _.findIndex(state.list, { cateName: '临时服务' });
        if (cateName !== -1) {
            state.cateNameList = _.flattenDepth(_.map(state.list[state.list.length - 1].children, (item) => {
                if (item.serverName) {
                    return item.serverName;
                }
                return [];
            }));
        } else {
            state.cateNameList = [];
        }
    },
    [GET_SERVICE_LIST_FAILURE](state) {
        state.loading = false;
    },
    [SERVICE_LIST_CHOOSE_ITEM](state, chosenIds) {
        // 根据ID更新已选服务
        state.chosen = _.map(chosenIds, (id) => {
            const index = _.findIndex(state.chosen, { serverId: id });
            return Object.assign({}, state.chosen[index]);
        });

        // 总计
        let total = 0;

        _.forEach(state.chosen, (item, index) => {
            state.chosen[index].initNum = state.chosen[index].initNum || 0;
            total += item.total;
        });

        state.serviceTotal = total;
    },
    [SERVICE_LIST_CHOOSE_ADD_ITEM](state, item) {
        // 添加服务
        const cardForServiceK = Object.keys(state.cardForService);

        state.chosen.push(Object.assign({}, item, {
            count: 1,
            price: item.serverPrice,
            total: cardForServiceK.indexOf(`${item.serverId}`) < 0 ? item.serverPrice : 0,
            masterWorkerIds: [],
            masterWorker: [],
        }));

        let total = 0;

        _.forEach(state.chosen, (item) => {
            total += item.total;
        });

        state.serviceTotal = total;
    },
    [EDIT_SERVICVE_ITEM_PROPS](state, { id, k, val }) {
        // 编辑服务项， 数量， 小计， 删除， 服务师傅, 再计算服务总计
        const itemIndex = _.findIndex(state.chosen, { serverId: id });

        state.chosen[itemIndex][k] = val;

        let total = 0;

        _.forEach(state.chosen, (item) => {
            total += item.total;
        });

        state.serviceTotal = total;
    },
    [UPDATE_CHOSEN_SERVICE_IDS](state, ids) {
        // 从已选列表CheckBox取消
        state.chosenIds = JSON.parse(JSON.stringify(ids));
    },
    [UPDATE_CHOSEN_SERVICE_WORKERS](state, list) {
        _.forEach(state.chosen, (item, index) => {
            const temp = list[index].masterWorkerIds;
            const tempWorker = list[index].masterWorker;
            if (item.serverId === list[index].serverId) {
                // 统一修改, 一个服务ID(不管核销 | 普通服务), 都用同样的服务师傅
                state.chosen[index].masterWorkerIds = JSON.parse(JSON.stringify(temp));
                state.chosen[index].masterWorker = JSON.parse(JSON.stringify(tempWorker));
            }
        });
    },
    // [CUSTOMIZE_SERVICE_CACHE](state, service) {
    //     // 初始化自定义服务, 去重
    //     _.each(service, (item) => {
    //         const index = _.findIndex(state.customize,
    //             sItem => sItem.serverName === item.serverName);
    //         if (index >= 0) {
    //             state.customize[index] = item;
    //         } else {
    //             state.customize.push(item);
    //         }
    //     });
    // },
    [SERVICE_LIST_CONFIG_RESET](state) {
        // 重置
        _.extend(state, _.cloneDeep({
            loading: false,
            list: [],
            chosen: [],
            allService: [],
            serviceTotal: 0,
            chosenIds: [],
            // customize: [],
            boughtServiceList: [],
            cardList: [],
            cardForService: {},
        }));
    },
    [SERIALIZE_CARD_FOR_SERVICE](state, { serverInfo, isCopy, recover}) {
        // 初始化爱车卡数据, 按照服务拆分
        /**
         * {
         *      max: Number,
         *      cards: [{ card_id: '', card_name: '', num: Number }, ...]
         * }
         */
        const cacheCardForService = {};
        _.each(state.cardList, (item) => {
            _.each(item.service, (server) => {
                const id = `${server.serverId}`;
                if (!id) return;

                // 挂账订单, 查找订单中爱车卡信息
                const serverIndex = _.findIndex(serverInfo, sitem => `${sitem.serverId}` === `${server.serverId}`);
                if (!cacheCardForService[id]) {
                    // 如果服务单中有勾选, 则直接赋值
                    const cacheList = [];
                    if (serverIndex > -1 && !isCopy) {
                        if (serverInfo[serverIndex].cards) {
                            serverInfo[serverIndex].cards.forEach((item) => {
                                // eslint-disable-next-line no-param-reassign
                                cacheList.push(`${item}-card`);
                            });
                        }
                        if (serverInfo[serverIndex].services) {
                            serverInfo[serverIndex].services.forEach((item) => {
                                // eslint-disable-next-line no-param-reassign
                                cacheList.push(`${item}-service`);
                            });
                        }
                        if (serverInfo[serverIndex].specs) {
                            serverInfo[serverIndex].specs.forEach((item) => {
                                // eslint-disable-next-line no-param-reassign
                                cacheList.push(`${item}-spec`);
                            });
                        }
                    }
                    cacheCardForService[id] = {
                        max: serverIndex > -1 && !isCopy ? serverInfo[serverIndex].free : server.num,
                        useCard: true,
                        cards: [{
                            card_id: `${item.card_id}`,
                            card_name: item.card_name,
                            num: server.num,
                            card_type: item.card_type,
                            order_sn: item.order_sn,
                            expire_status: item.expire_status
                        }],
                        cardChosen: serverIndex > -1 && !isCopy ? cacheList : [`${item.card_id}-${item.card_type}`], // 再来一单 核销默认全选
                    };
                } else {
                    cacheCardForService[id].useCard = true;
                    cacheCardForService[id].cards.push({
                        card_id: `${item.card_id}`,
                        card_name: item.card_name,
                        num: server.num,
                        card_type: item.card_type,
                        order_sn: item.order_sn,
                        expire_status: item.expire_status
                    });
                    // 新开单和编辑挂账订单区别处理
                    // 编辑订单不在push
                    if (serverIndex < 0 || isCopy) { // 再来一单 核销默认全选
                        cacheCardForService[id].max += server.num;
                        cacheCardForService[id].cardChosen.push(`${item.card_id}-${item.card_type}`);
                    }
                }
            });
        });
        state.cardForService = cacheCardForService;
        if (recover) {
            const cacheCanUseService =  Object.keys(state.cardForService);
            let total = 0;

            _.forEach(state.chosen, (item, index) => {
                if (cacheCanUseService.indexOf(item.serverId.toString()) !== -1) {
                    const buyNum = state.cardForService[item.serverId.toString()].max < item.count ? item.count - state.cardForService[item.serverId.toString()].max : 0;
                    state.chosen[index].total = buyNum * item.price;
                }
                total += state.chosen[index].total;
            });

            state.serviceTotal = total;
        }
    },
    [UPDATE_CARD_FOR_SERVICE](state, { id, k, v }) {
        // 编辑爱车卡每项内容
        if (!id || !state.cardForService[id]) return;
        const serverIndex = _.findIndex(state.chosen, item => `${item.serverId}` === `${id}`);
        // 编辑需要重新计算小计, 总计, 是否存在小计为零
        state.chosen[serverIndex].initNum++;
        state.cardForService[id][k] = v;
        if (k === 'max') {
            state.cardForService[id].useCard = v !== 0;
            if (state.chosen[serverIndex].count - v > 0) {
                if (state.chosen[serverIndex].initNum > 2) {
                    state.chosen[serverIndex].total = (state.chosen[serverIndex].count - v) * state.chosen[serverIndex].price;
                }
            } else {
                state.chosen[serverIndex].total = 0;
            }

            let total = 0;

            _.forEach(state.chosen, (item) => {
                total += item.total;
            });

            state.serviceTotal = total;
        }
    },
    [GET_USER_STORE_CARDS_REQUEST](state) {
        // 请求爱车卡列表前, 清空列表(列表为一次性渲染)
        state.cardLoading = true;
        state.cardList = [];
        _.extend(state, _.cloneDeep({cardForService: {}}));
    },
    [GET_USER_STORE_CARDS_SUCCESS](state, { all_use_card_list = [] }) {
        state.cardLoading = false;
        state.cardList = state.cardList.concat(all_use_card_list);
    },
    [GET_USER_STORE_CARDS_FAILURE](state) {
        const cacheCanUseService =  Object.keys(state.cardForService);

        // 重置手机号相关的核销
        state.cardLoading = false;
        state.cardList = [];
        _.extend(state, _.cloneDeep({cardForService: {}}));

        let total = 0;

        _.forEach(state.chosen, (item, index) => {
            if (cacheCanUseService.indexOf(item.serverId.toString()) !== -1) {
                state.chosen[index].total = item.count * item.price;
            }
            total += state.chosen[index].total;
        });

        state.serviceTotal = total;
    },
    // 已购服务
    [GET_BOUGHT_SERVICE_LIST_SUCCESS](state, res = []) {
        state.boughtServiceList = res;
    },
    [GET_BOUGHT_SERVICE_LIST_FAILURE](state) {
        state.boughtServiceList = [];
    },
    [GET_WRITEOFF_AUTH](state, {num, list}) {
        state.hideOrderNum = num;
        state.writeoffAuthList = list;
    },
};

export const actions = {
    initChosenService({ commit }, detail) {
        const {setChosenServiceIds, setChosenService} = detail;
        commit(INIT_ORDER_CHOSEN_SERVICE, setChosenService);
        commit(INIT_ORDER_CHOSEN_SERVICE_IDS, setChosenServiceIds);
    },
    async getStoreService({ commit }) {
        commit(GET_SERVICE_LIST_REQUEST);
        const res = await Vue.$ajax.get('getStoreService');

        if (!res.errorType) {
            commit(GET_SERVICE_LIST_SUCCESS, res);
        } else {
            commit(GET_SERVICE_LIST_FAILURE);
        }
        // Vue.$storage.init();
        // commit(GET_SERVICE_LIST_REQUEST);

        // Vue.$storage.getLocal('STORE_SERVICE').then(async (lService) => {
        //     console.log(lService, 'pp');

        //     if (_.isEmpty(lService) || _.isEmpty(lService.common)) {
        //         // 层级放到data.common, 所以加多一层判断
        //         const res = await Vue.$ajax.get('getStoreService');

        //         if (!res.errorType) {
        //             Vue.$storage.update('STORE_SERVICE', res);
        //             commit(GET_SERVICE_LIST_SUCCESS, res);
        //         } else {
        //             commit(GET_SERVICE_LIST_FAILURE);
        //         }
        //     } else {
        //         commit(GET_SERVICE_LIST_SUCCESS, lService);
        //     }
        // }).catch(async () => {
        //     const res = await Vue.$ajax.get('getStoreService');

        //     if (!res.errorType) {
        //         Vue.$storage.update('STORE_SERVICE', res);
        //         commit(GET_SERVICE_LIST_SUCCESS, res);
        //     } else {
        //         commit(GET_SERVICE_LIST_FAILURE);
        //     }
        // });
    },
    // customizeServiceCache({ commit }, chosenCustomService) {
    //     commit(CUSTOMIZE_SERVICE_CACHE, chosenCustomService);

    //     Vue.$storage.update('STORE_SERVICE', {
    //         customize: state.customize,
    //         common: state.list
    //     });
    // },
    // 添加临时服务
    addTemporaryServiceCache({ commit }, service) {
        commit(TEMPORARY_SERVICE_CACHE, service);
    },
    getUserAllCards({ commit }, { mobile, order_id: orderId, serverInfo = [], isCopy = 0, recover = 0 }) {
        commit(GET_USER_STORE_CARDS_REQUEST);

        const rangeCardList = async () => {
            const res = await Vue.$ajax.get('getAllCard', {
                mobile,
                orderId
            });
            if (!res.errorType) {
                const {
                    boughtServiceList,
                    all_use_card_list,
                } = res;
                commit(GET_USER_STORE_CARDS_SUCCESS, { all_use_card_list});
                commit(SERIALIZE_CARD_FOR_SERVICE, { serverInfo, isCopy, recover});
                commit(GET_BOUGHT_SERVICE_LIST_SUCCESS, boughtServiceList);
            } else {
                commit(GET_USER_STORE_CARDS_FAILURE);
                commit(GET_BOUGHT_SERVICE_LIST_FAILURE);
            }
        };

        rangeCardList();
    },
    updateCardForService({ commit }, params) {
        commit(UPDATE_CARD_FOR_SERVICE, params);
    },
    serviceChosenUpdate({ commit }, ids) {
        commit(SERVICE_LIST_CHOOSE_ITEM, ids);
    },
    addServiceItem({ commit }, item) {
        commit(SERVICE_LIST_CHOOSE_ADD_ITEM, item);
    },
    editChosenServiceItem({ commit }, valObj) {
        commit(EDIT_SERVICVE_ITEM_PROPS, valObj);
    },
    updateChosenServiceIds({ commit }, ids) {
        commit(UPDATE_CHOSEN_SERVICE_IDS, ids);
    },
    updateServiceWorkers({ commit }, list) {
        commit(UPDATE_CHOSEN_SERVICE_WORKERS, list);
    },
    resetAddService({ commit }) {
        commit(SERVICE_LIST_CONFIG_RESET);
    },
    async getWriteoffAuth({ commit }, obj) {
        const res = await Vue.$ajax.get('getWriteoffAuthDetail', {
            mobile: obj.mobile,
            serverId: obj.serverId || ''
        });
        commit(GET_WRITEOFF_AUTH, res);
    }
};

export default {
    state,
    mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/serviceList.js